import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../constants/common'
import { useDraftFlushOnUnmount } from '../../Draft'
import { useEmailCreationFormConfirmation, useEmailDraft } from '../Email.hooks'

function EmailReplyFormContainer({
  children,
  getIsDirty,
  isCloseConfirm,
  modal,
  onCancel,
  onCloseConfirmation,
}) {
  const { values } = useFormikContext()

  const { getLatestDraft, setDraft } = useEmailDraft()

  useDraftFlushOnUnmount({ getIsDirty, getLatestDraft, setDraft })

  const { Confirmation, handleSubmitConfirm } =
    useEmailCreationFormConfirmation({ onClose: onCancel })

  function handleSubmitConfirmation(value) {
    handleSubmitConfirm(values, EMPTY_LIST, value)
  }

  return (
    <>
      {children}
      {modal}
      {isCloseConfirm ? (
        <Confirmation
          onCancel={onCloseConfirmation}
          onSubmit={handleSubmitConfirmation}
        />
      ) : null}
    </>
  )
}

export default EmailReplyFormContainer
